import React, { useState, useEffect } from "react";
import { Checkbox, Input, List, Pagination, Space, Spin } from "antd";
import { CaretDownFilled, SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import FilterBullet from "../../../helpers/components/filter_bullet";

const CustomerFilter = ({
                            searchText,
                            setSearchText,
                            fetchCustomers,       // async function to fetch activities
                            filter = {},          // contains filter.customer_ids
                            onChange,             // (key, value) => void
                        }) => {
    const [localState, setLocalState] = useState({
        loading: false,
        customers: [],
        count: 0,
        page: 1,
        size: 10,
    });

    // Main data fetching function
    const loadCustomers = async (page = 1) => {
        setLocalState(prev => ({ ...prev, loading: true }));

        const result = await fetchCustomers({
            search: searchText,
            page: page, // backend usually 0-indexed
            size: localState.size
        });

        const customers = result?.rows || [];
        const count = result?.count || 0;

        setLocalState(prev => ({
            ...prev,
            loading: false,
            customers,
            count,
            page, // update current page
        }));
    };

    // Load activities on first render or when search changes
    useEffect(() => {
        loadCustomers(1); // reset to page 1 on search change
    }, [searchText]);

    return (
        <FilterBullet
            popover={
                <Spin
                    spinning={localState.loading}
                    indicator={<LoadingOutlined style={{ color: 'var(--main-color)' }} />}
                >
                    <div>
                        <Input
                            prefix={<SearchOutlined style={{ color: 'var(--secondary-text-color)' }} />}
                            placeholder='Search Customer'
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>

                    <Checkbox.Group
                        value={filter.customer_ids || []}
                        onChange={(checkedValues) => onChange('customer_ids', checkedValues)}
                    >
                        <List
                            style={{ width: 280 }}
                            dataSource={localState.customers}
                            renderItem={(item) => {
                                const { customer_id, name, phone_no, mobile_dial_no } = item ?? {};
                                return (
                                    <List.Item style={{ width: '100%' }} key={customer_id}>
                                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                            <div>
                                                <div style={{ fontWeight: 500 }}>{name || '-'}</div>
                                                <div style={{ color: '#888' }}>
                                                    {mobile_dial_no || ''}{phone_no || ''}
                                                </div>
                                            </div>
                                            <div style={{ marginLeft: 'auto' }}>
                                                <Checkbox value={customer_id} />
                                            </div>
                                        </div>
                                    </List.Item>
                                );
                            }}
                        />
                    </Checkbox.Group>

                    <div style={{ margin: '16px 0' }}>
                        <Pagination
                            showSizeChanger={false}
                            pageSize={localState.size}
                            onChange={(page) => loadCustomers(page)}
                            current={localState.page}
                            total={localState.count}
                        />
                    </div>
                </Spin>
            }
        >
            <div>
                <Space>
                    <div>
                        <span>
                            Customer
                            {
                                filter.customer_ids?.length > 0 &&
                                `: ${filter.customer_ids
                                    .map(id => {
                                        const cust = localState.customers?.find(x => x.customer_id === id);
                                        return cust ? `${cust.mobile_dial_no}${cust.phone_no}` : '';
                                    })
                                    .join(', ')}`
                            }
                        </span>
                    </div>
                    <div>
                        <CaretDownFilled style={{ color: '#a0aec0' }} />
                    </div>
                </Space>
            </div>
        </FilterBullet>
    );
};

export default CustomerFilter;
